// extracted by css-extract-rspack-plugin
export default {"header":"Xg_APihtKDAOhCXj","back":"aT4BarFwQFcd4ivS","backIcon":"WHJxAI0IlvEDHXSJ","crumbs":"Vlz_ggZD19UFWV2a"};